
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import Container from "../ui/Container";

const Services = () => {
  const services = [
    {
      id: "web-dev",
      name: "Разработка веб-приложений",
      description: "Создаем современные, быстрые и масштабируемые веб-приложения для решения бизнес-задач любой сложности.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m18 16 4-4-4-4"></path>
          <path d="m6 8-4 4 4 4"></path>
          <path d="m14.5 4-5 16"></path>
        </svg>
      )
    },
    {
      id: "mobile-dev",
      name: "Разработка мобильных приложений",
      description: "Разрабатываем нативные и кроссплатформенные мобильные приложения для iOS и Android, используя передовые технологии.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect width="14" height="20" x="5" y="2" rx="2" ry="2"></rect>
          <path d="M12 18h.01"></path>
        </svg>
      )
    },
    {
      id: "ecommerce",
      name: "Разработка e-commerce решений",
      description: "Создаем и интегрируем современные решения для электронной коммерции, помогающие увеличить продажи и улучшить обслуживание клиентов.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="8" cy="21" r="1"></circle>
          <circle cx="19" cy="21" r="1"></circle>
          <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path>
        </svg>
      )
    },
    {
      id: "integration",
      name: "Интеграция систем",
      description: "Обеспечиваем бесшовную интеграцию различных систем и приложений для создания единой работающей экосистемы вашего бизнеса.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 2v7"></path>
          <path d="M12 2v4"></path>
          <path d="M21 13v6"></path>
          <path d="M12 17v4"></path>
          <path d="M20 2h-6a2 2 0 0 0-2 2v12.5"></path>
          <path d="M17 5h-1a2 2 0 0 0-2 2v1.5"></path>
          <path d="M10 2H7a2 2 0 0 0-2 2v17a2 2 0 0 0 2 2h7"></path>
          <path d="M22 19H10"></path>
        </svg>
      )
    }
  ];

  return (
    <section className="py-20 bg-secondary relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute right-1/4 top-1/4 w-1/4 h-1/4 bg-primary/5 rounded-full blur-3xl"></div>
        <div className="absolute left-1/4 bottom-1/4 w-1/4 h-1/4 bg-accent/5 rounded-full blur-3xl"></div>
      </div>

      <Container>
        <div className="flex flex-col lg:flex-row items-start lg:space-x-16">
          <div className="lg:w-5/12 mb-12 lg:mb-0 lg:sticky lg:top-24">
            <div className="tag mb-4">Наши услуги</div>
            <h2 className="heading text-3xl md:text-4xl font-bold mb-6">
              Комплексные <span className="text-gradient">услуги разработки</span> для вашего бизнеса
            </h2>
            <p className="text-muted-foreground text-lg mb-8">
              Мы предлагаем полный спектр услуг по разработке программного обеспечения для бизнеса. Наша команда экспертов поможет вам реализовать проекты любой сложности — от простых веб-приложений до комплексных enterprise-решений.
            </p>
            <Link to="/services" className="button-primary">
              Все услуги
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </div>

          <div className="lg:w-7/12">
            <div className="space-y-6">
              {services.map((service, index) => (
                <div 
                  key={service.id} 
                  className="relative group bg-white rounded-2xl p-6 shadow-sm border border-border hover:border-primary/20 hover:shadow-md transition-all duration-300"
                >
                  <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-accent/5 opacity-0 group-hover:opacity-100 rounded-2xl transition-opacity duration-300"></div>
                  <div className="relative z-10">
                    <div className="w-12 h-12 bg-secondary flex items-center justify-center rounded-lg mb-5 text-primary">
                      {service.icon}
                    </div>
                    <h3 className="text-xl font-semibold mb-3">{service.name}</h3>
                    <p className="text-muted-foreground mb-5">{service.description}</p>
                    {/* <Link to={`/services/${service.id}`} className="inline-flex items-center text-primary font-medium">
                      Подробнее
                      <ArrowRight className="ml-2 h-4 w-4 transform group-hover:translate-x-1 transition-transform duration-200" />
                    </Link> */}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Services;
